import { CustomWebsocketProvider } from '~/components/YJSDocument/YJSDocumentProvider/CustomWebsocketProvider'
import * as Y from 'yjs'
import { IndexeddbPersistence } from 'y-indexeddb'
import { env } from '~/env.mjs'
import { CustomDoc } from '~/components/YJSDocument/YJSDocumentProvider/CustomDoc'

const SYNC_ENABLED_PREFIX = 'evaluation-sync-enabled-'

class ProviderManager {
  static providers: Map<string, CustomWebsocketProvider> = new Map()

  static getProvider(
    roomName: string,
    memberId: string,
    doc: CustomDoc
  ): CustomWebsocketProvider {
    if (!ProviderManager.providers.has(roomName)) {
      // Check localStorage for sync state - defaults to true if not found
      let syncEnabled = true
      if (typeof window !== 'undefined') {
        const stored = localStorage.getItem(`${SYNC_ENABLED_PREFIX}${roomName}`)
        syncEnabled = stored === null ? true : stored === 'true'
      }

      console.log(
        `%c[ProviderManager] Creating new provider for room: ${roomName}`,
        'color: #00ff00; font-weight: bold;',
        { syncEnabled }
      )
      const newProvider = new CustomWebsocketProvider(
        env.NEXT_PUBLIC_WS_URL,
        roomName,
        doc,
        memberId,
        { connect: false, syncEnabled }
      )
      /**
       * salman/websocket-fixes
       * Only have one IndexeddbPersistence per doc,
       * and that is already being created in EvaluationProvider
       */
      // new IndexeddbPersistence(doc.guid, doc);
      ProviderManager.providers.set(roomName, newProvider)
    } else {
      console.log(
        `%c[ProviderManager] Using existing provider for room: ${roomName}`,
        'color: #ff9900; font-weight: bold;'
      )
      const existingProvider = ProviderManager.providers.get(roomName)!
      // Ensure the existing provider is using the new doc
      if (existingProvider.doc !== doc) {
        console.log(
          `%c[ProviderManager] Updating doc for existing provider: ${roomName}`,
          'color: #ff9900; font-weight: bold;'
        )
        existingProvider.doc = doc
      }
    }
    return ProviderManager.providers.get(roomName)!
  }

  static resetProvider(roomName: string) {
    if (ProviderManager.providers.has(roomName)) {
      const provider = ProviderManager.providers.get(roomName)
      console.log(
        `%c[ProviderManager] Resetting provider for room: ${roomName}`,
        'color: #ff0000; font-weight: bold;'
      )
      provider?.disconnectBc()
      provider?.destroy()
      ProviderManager.providers.delete(roomName)
    }
  }

  // Helper method to check if a provider exists for a room
  static hasProvider(roomName: string): boolean {
    return ProviderManager.providers.has(roomName)
  }

  // Helper method to get existing provider's doc without modifying it
  static getExistingProviderDoc(roomName: string): CustomDoc | null {
    const provider = ProviderManager.providers.get(roomName)
    return provider?.doc || null
  }

  // Helper method to get provider status
  static getProviderStatus(roomName: string): {
    exists: boolean
    connected: boolean
  } {
    const provider = ProviderManager.providers.get(roomName)
    return {
      exists: !!provider,
      connected: provider?.wsconnected || false,
    }
  }
}

export default ProviderManager
